import "./Complete.scss";
import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Badge,
  SimpleGrid,
} from "@chakra-ui/react";
import { useIntl } from "react-intl";
import moment from "moment";
import "moment/locale/de";
import Products from "../../components/products/Products";
import { Reviews } from "../../components/reviews/Reviews";
import useStore from "../../storage/DataStore";
import { translation } from "../../utils/translation";
import FemaleBefore from "../../assets/step8/female-before.webp";
import FemaleAfter from "../../assets/step8/female-after.jpg";
import MaleBefore from "../../assets/step8/male-before.webp";
import MaleAfter from "../../assets/step8/male-after.jpg";

function Complete() {
  const intl = useIntl();
  let country = intl.locale;
  let unit = "kg";
  const state = useStore.getState();

  const fitnessCalculator = require("fitness-health-calculations");

  let weight = useStore((state) => state.weight);
  let targetWeight = useStore((state) => state.targetWeight);
  let weightDifference = weight - targetWeight;

  let calcWeight = parseInt(weight);
  let calcWeightDifference = weightDifference;
  let tDee = fitnessCalculator.tdee("male", 18, 180, calcWeight, "moderate");
  let estimatedDays = Math.round((calcWeightDifference * 7000) / tDee);
  let weightUnit = "kg";

  let estimatedEndDate = moment().add(estimatedDays, "days");
  // let startDate = moment(estimatedEndDate).subtract(7, "days");

  // const currentDate = moment().format("Do MMMM YYYY");

  // const estimatedStartDate = startDate.format("Do MMMM YYYY");
  const estimatedEndDateFormatted = estimatedEndDate.format("Do MMMM YYYY");

  const bodyBefore = state.gender === "male" ? MaleBefore : FemaleBefore;
  const bodyAfter = state.gender === "male" ? MaleAfter : FemaleAfter;

  return (
    <Container maxW={600} className="result-page">
      <Box
        mt={2}
        p={5}
        width={"100%"}
        background={"#fff"}
        color={"#000"}
        borderRadius="lg"
        mb={10}
        overflow={"hidden"}
      >
        <Heading
          fontSize={"md"}
          fontWeight={"normal"}
          px={[5, 10]}
          mb={2}
          textAlign="center"
        >
          {translation("general.step8.plan4.heading")}
        </Heading>

        <Heading
          px={[5, 10]}
          fontSize={["2xl", "3xl"]}
          mb={5}
          textAlign="center"
        >
          <div
            dangerouslySetInnerHTML={{
              __html: translation("general.step8.plan4.subHeading")
                .replace("<TARGET-WEIGHT>", `${targetWeight} ${unit}`)
                .replace("<ESTIMATED-DATE>", `${estimatedEndDateFormatted}`),
            }}
          ></div>
        </Heading>
        <Box maxW={600} margin="auto">
          <Box position={"relative"} mt={["60px", 100]}>
            <Box
              top={[-30, -50]}
              left={[10, 20]}
              position={"absolute"}
              background={"grey"}
              paddingTop={2}
              paddingBottom={2}
              paddingLeft={4}
              paddingRight={4}
              borderRadius={10}
            >
              {translation("general.step8.plan4.now")}
            </Box>
            <Box
              top={[-30, -50]}
              right={[10, 20]}
              position={"absolute"}
              background={"grey"}
              paddingTop={2}
              paddingBottom={2}
              paddingLeft={4}
              paddingRight={4}
              borderRadius={10}
            >
              {translation("general.step8.plan4.target")}
            </Box>
            <Box
              position={"absolute"}
              bottom={[35, 50]}
              right={[3, 50]}
              id="goal"
            >
              <Box
                background={"brand"}
                color={"white"}
                p={2}
                borderRadius={"md"}
                fontSize={16}
              >
                {targetWeight} {weightUnit}
              </Box>
            </Box>

            <Box
              position={"absolute"}
              bottom={[3, 6]}
              right={[7, 67]}
              background={"brand"}
              width={5}
              height={5}
              borderRadius={10}
              borderWidth={3}
              borderColor={"white"}
            ></Box>

            <Box mx={-5} mb={-5}>
              <svg
                width="100%"
                // height="100%"
                viewBox="0 0 360 215"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                // style={{ height: "fit-content" }}
              >
                <g>
                  <path
                    strokeWidth="2"
                    stroke="#cde6ff"
                    d="m1.90317,212.92857"
                  ></path>
                  <path
                    stroke="null"
                    fill="#cde6ff"
                    d="m360,191.06765c-109.96311,5.54168 -173.55631,-31.70359 -250.38226,-96.50748c-34.44129,-33.67016 -72.24027,-79.82148 -109.50695,-79.82148l0,200.2613l359.88921,0l0,-23.93233l0,-0.00001z"
                    opacity="0.7"
                  ></path>
                  <path
                    stroke="#6ca2d8"
                    className="weightGraphicPath"
                    strokeWidth="3"
                    d="M0.7142999999999802,13.857020000000006C39.37223999999998,13.857020000000006 75.29193999999998,63.15854000000001 109.64096999999998,94.58097000000001C179.17647999999997,158.19135 249.31622999999996,199.24315 358.69744,193.5603"
                  ></path>
                </g>
              </svg>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        border={"1px #e0e3eb solid"}
        borderRadius={"lg"}
        mt={[3, 5]}
        background={"white"}
        mb={10}
        overflow={"hidden"}
      >
        <SimpleGrid className={"before-after"} columns={2} textAlign={"center"}>
          <Box>
            <Box p={3}>
              <Heading fontSize={"lg"} mb={3}>
                {translation("general.step8.plan4.now")}
              </Heading>

              <Image display={"inline-block"} height={150} src={bodyBefore} />

              <Text>
                {translation("general.step8.plan4.now")}:{" "}
                <Text fontWeight={"bold"} display={"inline"}>
                  {weight} {weightUnit}
                </Text>
              </Text>
            </Box>

            <Box p={4} background={"secondary"}>
              <Text fontSize={"md"} fontWeight={"bold"}>
                {translation("general.step8.plan4.bodyFat")}
              </Text>
              <Badge backgroundColor={"#F2AAB9"}>30-45%</Badge>
            </Box>
          </Box>
          <Box>
            <Box p={3}>
              <Heading fontSize={"lg"} mb={3} className={"stroke"}>
                {translation("general.step8.plan4.target")}
              </Heading>

              <Image display={"inline-block"} height={150} src={bodyAfter} />

              <Text>
                {translation("general.step8.plan4.target")}:{" "}
                <Text fontWeight={"bold"} color={"#238AC6"} display={"inline"}>
                  {targetWeight} {weightUnit}
                </Text>
              </Text>
            </Box>

            <Box p={4} background={"secondary"}>
              <Text fontSize={"md"} fontWeight={"bold"}>
                {translation("general.step8.plan4.bodyFat")}
              </Text>
              <Badge colorScheme="green">27-37%</Badge>
            </Box>
          </Box>
        </SimpleGrid>
      </Box>

      <Box display={"flex"} justifyContent={"center"}>
        <Box
          width={"100%"}
          background={"#fff"}
          color={"#000"}
          borderRadius="lg"
          alignSelf={"center"}
          borderColor={"#ededed"}
          p={5}
        >
          <Products country={country} totalDays={estimatedDays} />
        </Box>
      </Box>

      <Box textAlign={"center"} mt={10}>
        <button
          onClick={() => {
            window.location.href = document
              .querySelector("#voluum_click_url_anchor")
              .getAttribute("href");
          }}
          className="primary-btn pulse"
        >
          {translation("general.complete.product.button")}
        </button>
      </Box>

      {window.translations.reviews.length > 0 && (
        <Box
          mt={5}
          p={5}
          width={"100%"}
          background={"#fff"}
          color={"#000"}
          borderRadius="lg"
        >
          <Reviews country={country} />
        </Box>
      )}

      {window.translations.reviews.length > 0 && (
        <Box textAlign={"center"} mt={10} pb={5}>
          <button
            onClick={() => {
              window.location.href = document
                .querySelector("#voluum_click_url_anchor")
                .getAttribute("href");
            }}
            className="primary-btn pulse"
          >
            {translation("general.complete.product.button")}
          </button>
        </Box>
      )}
    </Container>
  );
}

export default Complete;
